import React from 'react';

import GoogleDFP from 'components/GoogleDFP';
import loadAdConfig from 'utils/adConfig';

interface CompanionAdProps {
  entitlements: string[];
  adConfigName: string;
}

const CompanionAd = ({ entitlements, adConfigName }: CompanionAdProps) => {
  const adConfig = loadAdConfig(adConfigName, [], entitlements);
  return <GoogleDFP adConfig={adConfig} />;
};

export default CompanionAd;
